import { InAppNotification } from '../../api/Types';

export interface BrowserNotificationPayload {
  title: string;
  body: string;
  data: {
    url: string;
  };
}

type AppBadgeNavigator = Navigator & {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export const hasNotificationApi = (): boolean =>
  typeof window !== 'undefined' && 'Notification' in window;

export const getNotificationPermission = (): NotificationPermission =>
  hasNotificationApi() ? Notification.permission : 'default';

export const canShowSystemNotification = ({
  authorId,
  pwaMode,
  notificationApiAvailable,
  permission,
}: {
  authorId?: number;
  pwaMode: boolean;
  notificationApiAvailable: boolean;
  permission: NotificationPermission;
}) =>
  !!authorId &&
  pwaMode &&
  notificationApiAvailable &&
  permission === 'granted';

export const buildBrowserNotificationPayload = (
  notification: InAppNotification
): BrowserNotificationPayload => ({
  title: notification.title || 'Notification',
  body: notification.body || 'Nouveau contenu disponible.',
  data: { url: notification.route_path || '/' },
});

export const canSetAppBadge = ({
  unreadCount,
  permission,
  badgeNavigator,
}: {
  unreadCount: number;
  permission: NotificationPermission;
  badgeNavigator: AppBadgeNavigator;
}) => unreadCount > 0 && permission === 'granted' && !!badgeNavigator.setAppBadge;

export const shouldClearAppBadge = ({
  unreadCount,
  badgeNavigator,
}: {
  unreadCount: number;
  badgeNavigator: AppBadgeNavigator;
}) => unreadCount <= 0 && !!badgeNavigator.clearAppBadge;
